import { useState, useEffect } from "react";
import { getData } from '../../utils/apiCalls';
import { tracking } from '../../utils/tracking';
import { Link } from "react-router-dom";

import spons from '../../data/sponsors_home.json'

export const SponsorSection = () => {
   const [sponsors, setSponsors] = useState(spons);

   // useEffect(() => {
   //    getData("https://youngstartup.io/api/cwebsite/get_sponsors")
   //    .then((data) =>
   //       setSponsors(data)
   //    );
   // }, []);

   return (
      <div className='sponsors'>
         {sponsors.length > 0 && <h1 >OUR PARTNERS</h1>}
         {sponsors.map((sponsor_type, i) => {
            const { name, values } = sponsor_type;
            return (
               <div className='sponsor' key={i}>
                  <h3>{name.toUpperCase().replace(/_/g, " ")}</h3>
                  <div className='logos'>
                     {values.map(sponsor => (
                        <div key={sponsor.logo_url} className='logo'
                           onClick={() => tracking(282, sponsor.id)}
                        >
                           <a href={sponsor.website} rel='noreferrer' target='_blank'>
                              <img src={require("../../assets/imgs/sponsor-logos/" + sponsor.logo_url)} alt="" />
                           </a>
                        </div>
                     ))
                     }
                  </div>
               </div>
            )
         })}
          <div className="btn-container">
            <Link to='/partners' className="btn">Become a partner</Link>
         </div>
      </div>
   );
};
